import apiClient from "./apiClient";

/**
 * Fetch community feed
 */
export async function getPosts(

    category,

    page = 0,

    size = 10

){

    const response = await apiClient.get(

        "/api/posts",

        {

            params:{

                category,

                page,

                size

            }

        }

    );
    console.log("getPosts response:", response.data);

    return response.data;

}

/**
 * Fetch single post
 */
export async function getPost(postId){

    const response = await apiClient.get(

        `/posts/${postId}`

    );

    return response.data;

}

/**
 * Create Post
 */
export async function createPost(formData){

    const response = await apiClient.post(

        "/api/posts",

        formData,

        {

            headers:{

                "Content-Type":"multipart/form-data"

            }

        }

    );

    return response.data;

}

/**
 * Delete Post
 */
export async function deletePost(postId){

    await apiClient.delete(

        `/posts/${postId}`

    );

}

/**
 * Like
 */
export async function likePost(postId){

    const response = await apiClient.post(

        `/posts/${postId}/like`

    );

    return response.data;

}

/**
 * Unlike
 */
export async function unlikePost(postId){

    const response = await apiClient.delete(

        `/posts/${postId}/like`

    );

    return response.data;

}

/**
 * Bookmark
 */
export async function bookmarkPost(postId){

    const response = await apiClient.post(

        `/posts/${postId}/bookmark`

    );

    return response.data;

}

/**
 * Remove Bookmark
 */
export async function removeBookmark(postId){

    const response = await apiClient.delete(

        `/posts/${postId}/bookmark`

    );

    return response.data;

}

/**
 * Share
 */
export async function sharePost(postId){

    const response = await apiClient.post(

        `/posts/${postId}/share`

    );

    return response.data;

}